import React, { useEffect, useState } from "react";
import { SafeArea } from "capacitor-plugin-safe-area";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";
import {
  BookOpenIcon,
  CameraIcon,
  HomeIcon,
  UserIcon,
} from "@heroicons/react/24/outline";

import { useCommonStore } from "../../../store/commonStore";
import { useUserStore } from "../../../store/userStore";

function TabBar() {
  const { t } = useTranslation(["common"]);
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = useCommonStore((state) => state.activeTab);
  const setActiveTab = useCommonStore((state) => state.setActiveTab);

  const { accessToken } = useUserStore(
    useShallow((state) => ({
      accessToken: state.accessToken,
    }))
  );

  const [safeBottom, setSafeBottom] = useState(0);

  useEffect(() => {
    (async function () {
      if (import.meta.env.VITE_PLATFORM === "mobile") {
        const safeAreaData = await SafeArea.getSafeAreaInsets();
        const { insets } = safeAreaData;

        setSafeBottom(insets.bottom);
      }
    })();
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/exchange")) {
      setActiveTab("exchanges");
    } else if (location.pathname.includes("/gallery")) {
      setActiveTab("gallery");
    } else if (location.pathname.includes("/account")) {
      setActiveTab("account");
    } else {
      setActiveTab("home");
    }
  }, [location.pathname]);

  return (
    <>
      {import.meta.env.VITE_PLATFORM === "mobile" && (
        <nav
          className="fixed mx-2 bottom-0 left-0 right-0"
          style={{
            zIndex: 15,
            paddingBottom: safeBottom > 0 ? `${safeBottom}px` : "0px",
          }}
        >
          <ul
            className={`bg-surface-base text-text-inverted p-2 grid grid-cols-4 rounded-2xl border-1 border-border-faint shadow-2xl`}
          >
            <li
              className={`${
                activeTab === "home"
                  ? "bg-surface-secondary text-text-inverted font-bold"
                  : "bg-surface-base text-text-base"
              } rounded-xl p-2 text-xs text-center flex flex-col items-center justify-center gap-1`}
              onClick={() => {
                setActiveTab("home");
                navigate("/");
              }}
            >
              <HomeIcon
                className={`${activeTab === "home" ? "stroke-3" : ""} w-4 h-4`}
              />
              {t(`tabBar.home`)}
            </li>
            <li
              className={`${
                activeTab === "exchanges"
                  ? "bg-surface-secondary text-text-inverted font-bold"
                  : "bg-surface-base text-text-base"
              } rounded-xl p-2 text-xs text-center flex flex-col items-center justify-center gap-1`}
              onClick={() => {
                setActiveTab("exchanges");
                navigate("/exchanges/official");
              }}
            >
              <BookOpenIcon
                className={`${
                  activeTab === "exchanges" ? "stroke-3" : ""
                } w-4 h-4`}
              />
              {t(`tabBar.exchanges`)}
            </li>
            <li
              className={`${
                activeTab === "gallery"
                  ? "bg-surface-secondary text-text-inverted font-bold"
                  : "bg-surface-base text-text-base"
              } rounded-xl p-2 text-xs text-center flex flex-col items-center justify-center gap-1`}
              onClick={() => {
                setActiveTab("gallery");
                navigate("/gallery");
              }}
            >
              <CameraIcon
                className={`${
                  activeTab === "gallery" ? "stroke-3" : ""
                } w-4 h-4`}
              />
              {t(`tabBar.gallery`)}
            </li>
            {accessToken ? (
              <li
                className={`${
                  activeTab === "account"
                    ? "bg-surface-secondary text-text-inverted font-bold"
                    : "bg-surface-base text-text-base"
                } rounded-xl p-2 text-xs text-center flex flex-col items-center justify-center gap-1`}
                onClick={() => {
                  setActiveTab("account");
                  navigate("/account");
                }}
              >
                <UserIcon
                  className={`${
                    activeTab === "account" ? "stroke-3" : ""
                  } w-4 h-4`}
                />
                {t(`tabBar.account`)}
              </li>
            ) : (
              <li
                className={`${
                  activeTab === "login"
                    ? "bg-surface-secondary text-text-inverted font-bold"
                    : "bg-surface-base text-text-base"
                } rounded-xl p-2 text-xs text-center flex flex-col items-center justify-center gap-1`}
                onClick={() => {
                  setActiveTab("login");
                  navigate("/login");
                }}
              >
                <UserIcon
                  className={`${
                    activeTab === "login" ? "stroke-3" : ""
                  } w-4 h-4`}
                />
                {t(`tabBar.login`)}
              </li>
            )}
          </ul>
        </nav>
      )}
    </>
  );
}

export default TabBar;
